module.exports = __webpack_public_path__ + "img/83.8.TSS.b281ba57.png";